import { Action } from '@ngrx/store';
import { ISendingMessage, IMailingResult } from '@interfaces/ISendingMessage';

export enum EMailingsActions {
  //create
  CreateMailing = '[Mailings] Create',
  CreateMailingFailure = '[Mailings] Create Failure',
  CreateMailingSuccess = '[Mailings] Create Success',

  //get
  GetMailings = '[Mailings] Get All',
  GetMailingsFailure = '[Mailings] Get All Failure',
  GetMailingsSuccess = '[Mailings] Get All Success',

  //
  GetMailing = '[Mailings] Get',
  GetMailingFailure = '[Mailings] Get Failure',
  GetMailingSuccess = '[Mailings] Get  Success',

  //
  GetResults = '[Mailings] Get Results',
  GetResultsSuccess = '[Mailings] Get Results Success',
  GetResultsFailure = '[Mailings] Get Results Failure',

  //
  UpdateMailing = '[Mailings] Update Mailing',
  UpdateMailingSuccess = '[Mailings] Update Mailing Success',
  UpdateMailingFailure = '[Mailings] Update Mailing Failure',
}

//create
export class CreateMailing implements Action {
  public readonly type = EMailingsActions.CreateMailing;

  constructor(
    public mailing: ISendingMessage,
    public messageType?: 'Telegram'
  ) {}
}

export class CreateMailingFailure implements Action {
  public readonly type = EMailingsActions.CreateMailingFailure;

  constructor(public errors: { [key: string]: string[] }) {}
}

export class CreateMailingSuccess implements Action {
  public readonly type = EMailingsActions.CreateMailingSuccess;

  constructor(public mailing: ISendingMessage) {}
}

//get all
export class GetMailings implements Action {
  public readonly type = EMailingsActions.GetMailings;
  constructor(public messageType?: 'Telegram') {}
}

export class GetMailingsSuccess implements Action {
  public readonly type = EMailingsActions.GetMailingsSuccess;

  constructor(public mailings: ISendingMessage[]) {}
}

export class GetMailingsFailure implements Action {
  public readonly type = EMailingsActions.GetMailingsFailure;
}

// get
export class GetMailing implements Action {
  public readonly type = EMailingsActions.GetMailing;

  constructor(public id: number) {}
}

export class GetMailingSuccess implements Action {
  public readonly type = EMailingsActions.GetMailingSuccess;

  constructor(public mailing: ISendingMessage) {}
}

export class GetMailingFailure implements Action {
  public readonly type = EMailingsActions.GetMailingFailure;
}

// all-results
export class GetResults implements Action {
  public readonly type = EMailingsActions.GetResults;

  constructor(public id: number) {}
}

export class GetResultsSuccess implements Action {
  public readonly type = EMailingsActions.GetResultsSuccess;

  constructor(public results: IMailingResult[]) {}
}

export class GetResultsFailure implements Action {
  public readonly type = EMailingsActions.GetResultsFailure;
}

export class UpdateMailing implements Action {
  public readonly type = EMailingsActions.UpdateMailing;

  constructor(public mailing_id: number, public data: ISendingMessage) {}
}

export class UpdateMailingSuccess implements Action {
  public readonly type = EMailingsActions.UpdateMailingSuccess;

  constructor(public mailing_id: number, public data: ISendingMessage) {}
}

export class UpdateMailingFailure implements Action {
  public readonly type = EMailingsActions.UpdateMailingFailure;

  constructor(public errors: { [key: string]: string[] }) {}
}

export type MailingsActions =
  | CreateMailing
  | CreateMailingFailure
  | CreateMailingSuccess
  | GetMailings
  | GetMailingsFailure
  | GetMailingsSuccess
  | GetMailing
  | GetMailingFailure
  | GetMailingSuccess
  | GetResults
  | GetResultsSuccess
  | GetResultsFailure
  | UpdateMailing
  | UpdateMailingSuccess
  | UpdateMailingFailure;
